import { openDB } from 'idb';

const dbPromise = openDB('fileDB', 1, {
    upgrade(db) {
        if (!db.objectStoreNames.contains('files')) {
            db.createObjectStore('files');
        }
    },
});

export async function saveFile(key, fileBlob) {
    const db = await dbPromise;
    await db.put('files', fileBlob, key);
}

export async function getFile(key) {
    const db = await dbPromise;
    return await db.get('files', key);
}

export async function deleteFile(key) {
    const db = await dbPromise;
    await db.delete('files', key);
}

export async function clearDatabase() {
    const db = await dbPromise;
    const transaction = db.transaction('files', 'readwrite');
    const store = transaction.objectStore('files');
    await store.clear();
}